// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"6f5ab93f","81":"9bc0bdbf","128":"fa54826a","142":"f0f2014b","320":"094ccb42","346":"9275ef06","584":"13f66f72","630":"b42ce3e9","673":"a73d5a16","697":"95e546f4","746":"3472877c","947":"418e82be","956":"a9a69f58"}[chunkId] + ".chunk.js";
};